import { IModule, IModuleBuilder } from "app/IModule";
import OffersReducer from "./offers.reducer";
import OfferColumnConfigurationsReducer from "./offerColumnConfigurations.reducer";
import React from "react";

export default class OffersModule implements IModule {

    build(builder: IModuleBuilder) {
        const offersContractsLoader = React.lazy(() => import("./OffersContracts.page"))
        
        builder.addReducer("offers", new OffersReducer());
        builder.addReducer("offerColumnConfigurations", new OfferColumnConfigurationsReducer());
        builder.addRoute("/offers/:offerId/details", React.lazy(() => import("./OfferDetails.page")));
        builder.addRoute("/offers", offersContractsLoader);
        builder.addRoute("/contracts/basis", offersContractsLoader);
        builder.addRoute("/contracts/hta", offersContractsLoader);
        builder.addRoute("/contracts/cash", offersContractsLoader);
        builder.addRoute("/contracts/delayed-price", offersContractsLoader);
        builder.addRoute("/contracts/with-options", offersContractsLoader);
    }
}